/** Public address of the client cabinet (where clients log in), no trailing
 *  slash. Override at build time with REACT_APP_CABINET_URL. */
export const CABINET_URL = (process.env.REACT_APP_CABINET_URL || "https://comabooks.io").replace(/\/+$/, "");
